import { MENUBAR_ID } from "widgets/NavBar/NavBar";
import { BREAKPOINTS } from "design_system/src/hooks/useResizeObserver";

/**
 * Calculate the padding-top of the main content based on the Header height.
 * Header includes anything inside of the <header> tag.
 */
export const setMainPaddingTop = () => {
    const headerElement = document.getElementsByTagName("header")?.[0];
    const headerHeight = headerElement ? headerElement.clientHeight : 0;
    const isNarrowScreen = window.innerWidth < BREAKPOINTS.s768;
    const dropdownMenu = document.getElementById(MENUBAR_ID);
    const dropdownMenuHeight = dropdownMenu?.clientHeight || 0;

    if (isNarrowScreen && dropdownMenuHeight > 0) {
        return;
    }

    const mainContent = document.querySelector("main");
    mainContent?.style.setProperty("padding-top", `${headerHeight}px`);
};

/**
 * Attach listeners to the page and header elements for events where
 * the header size could possibly change.
 */
export const loadHeaderHeightObserver = () => {
    window.addEventListener("resize", setMainPaddingTop);
    window.addEventListener("load", setMainPaddingTop);

    const headerElement = document.querySelector("header");
    if (headerElement) {
        new MutationObserver(() => {
            // Wait until transitions from mutations have settled down
            requestIdleCallback(setMainPaddingTop);
        }).observe(headerElement as Element, {
            childList: true,
            subtree: true,
            attributeFilter: ["style", "class"],
        });
    }

    setMainPaddingTop();
};
